// The link out to SAFT-AI, shared by the staff sidebar and the client portal.
//
// It lived as a private const in OperationsLayout until 2026-09-29, which is part
// of why the portal never got one: there was nothing to reuse, so mirroring it
// meant retyping a production hostname. One exported constant, two consumers.

// Lands on /dashboard rather than the host root, so an already logged-in user
// arrives on their workspace instead of a landing/redirect page. Navigates in the
// SAME tab (no target="_blank") on both sides — SAFT-AI and this platform are one
// product to the user, and a new tab per hop leaves them with a pile of them.
export const SAFTAI_DASHBOARD_URL = 'https://saftaibyalaverde.jaconsultores.pt/dashboard'

// NO GATE. It was gated on `client_users.source` for a day: 'saftai' saw the
// link, 'standalone' did not, on the reasoning that a standalone user has no
// SAFT-AI account and would land on a login they cannot pass.
//
// Reverted 2026-09-29, and the reason is worth keeping. `source` records how the
// row was CREATED here — synced from the Ops-Center, or auto-provisioned from
// clients.contact_emails — which is not the same question as whether the person
// has a SAFT-AI account. It is a proxy, and a leaky one: Diogo's own portal
// accounts split across both values, so the link was invisible to him on the
// address he tests with and the feature looked undeployed.
//
// The two failure modes are not symmetric. A link shown to someone with no
// account is a login page they recognise as not theirs — self-explanatory, and
// they leave. A link HIDDEN from someone who does have an account is invisible:
// nothing to see, nothing to report, no way to tell it from a broken deploy.
// Prefer the legible failure.
